/*
 * Copyright (c) 2021 LucidResolutions LLC. All rights reserved.
 */

import React, {useContext, useEffect, useRef, useState} from "react";
import {PrivateRoute} from "../component/private.route";
import {Alert, Button, Layout, Menu, Select} from 'antd';
import {
    PieChartOutlined,
    PoweroffOutlined,
    HomeOutlined,
    ShoppingCartOutlined,
    SettingOutlined,
    SafetyCertificateOutlined
} from '@ant-design/icons';
import "../App.less"
import AuthService from "../service/auth.service";
import {Link, useHistory, useLocation} from "react-router-dom";
import {AuthContext} from "../context/auth.context";
import {ExchangeContext} from "../context/exchange.context";
import {IfEqual, IfTruthy} from "../component/if.equal.component";
import {UserProgressComponent} from "../component/user.progress.component";
import logo from "../logo-dark.svg";

const { SubMenu } = Menu;
const { Option } = Select;
const { Header, Content, Sider, Footer } = Layout;
let authSVC = new AuthService()


interface Props {
    collapsed: boolean;
    showOnCollapsed: boolean;
}

// @ts-ignore
const InternalLayout = ({ component: Component, ...rest }) =>{
    const location: any = useLocation()
    const [currentPath, setCurrentPath] = useState('')
    const authContext = useContext(AuthContext)
    const history = useHistory()
    const [year, _] = useState((new Date()).getFullYear())
    const [collapsed, setCollapsed] = useState(false)
    const exchangeContext = useContext(ExchangeContext)


    useEffect(()=>{
        setCurrentPath(location.pathname)
    }, [location])

    const menuClick = (e: any) =>{
        switch (e.key){
            case "logout":
                authSVC.removeToken()
                authContext.setToken(undefined)
                history.push('/login')
                break;
        }
    }

    return (
        <PrivateRoute {...rest} render={(props: any) => (
            <Layout style={{minHeight:"100vh"}}>
                <Sider
                    collapsible
                    breakpoint="lg"
                    collapsedWidth="0"
                    onBreakpoint={broken => {
                        if(broken){
                            setCollapsed(true)
                        }
                    }}
                    onCollapse={(collapsed, type) => {
                        setCollapsed(collapsed)
                    }}
                >
                    <Header style={{padding: 0}}>
                        <IfEqual expect={false} actual={collapsed}>
                            <img style={{maxHeight: '80%'}} src={logo}/>
                        </IfEqual>
                    </Header>
                    <Menu mode="inline" selectedKeys={[currentPath]} onClick={menuClick}>
                        <Menu.Item key="/" icon={<HomeOutlined />}>
                            <Link to={'/'}>Dashboard</Link>
                        </Menu.Item>
                        <Menu.Item key="/settings" icon={<SettingOutlined />}>
                            <Link to={'/settings'}>Settings</Link>
                        </Menu.Item>
                        <Menu.Item key={'logout'} icon={<PoweroffOutlined />}>Log Out</Menu.Item>
                    </Menu>
                </Sider>
                <Layout>
                    <Header className="site-layout-sub-header-background" style={{padding: 0}}>
                        <IfEqual expect={true} actual={collapsed}>
                            <img style={{maxHeight: '80%'}} src={logo}/>
                        </IfEqual>
                    </Header>
                    <Content style={{}}>
                    <div className="site-layout-background" style={{ padding: 24 }}>
                            <IfTruthy val={!authContext.userStatus}>
                                <div style={{marginBottom: 10}}>
                                    <Alert banner={true}
                                           message={"Subscription Expired"}
                                           description={"Your defender will not run until you renew your subscription."} action={
                                        <Button size="small" danger type="ghost" onClick={()=>{
                                            history.replace('/settings', {
                                                billing: true,
                                            })
                                        }}>
                                            Renew Subscription
                                        </Button>
                                    } type="error" showIcon />
                                </div>

                            </IfTruthy>
                            <UserProgressComponent/>
                            <Component {...props} />
                        </div>
                    </Content>
                    <Footer style={{ textAlign: 'center' }}>Lucid Tactics ©{year}</Footer>
                </Layout>
            </Layout>

        )} />
    )
}

export {InternalLayout}
